<app-spinner [isLoading]="isLoading"></app-spinner>
<p-toast></p-toast>

<p-dialog header="Parcel Image Details" [(visible)]="displayDialog" [modal]="true" (onHide)="resetModalState()"
  [closable]="true" [style]="{width: '80vw'}">
  @if (displayDialog && selectedRow && !recordNotFound) {
    @if (selectedRow) {
      <app-parcel-detail [parcel]="selectedRow" (notFound)="handleRecordNotFound()"
      (apiSuccess)="onApiSuccessFromModal($event)" (close)="displayDialog = false"></app-parcel-detail>
    }
  } @else {
    <p class="text-danger"> Record Not found</p>
  }

</p-dialog>
<app-dashboard-filters [cameraList]=cameraList [itemCodes]=itemCodes [filterOptions]=filterOptions [userLists]=users
(filterAppliedEvent)="receiveFilterApplied($event)" (clearFilterEvent)="receiveClearFilter()"></app-dashboard-filters>

<div class="grid">
  <div class="col-12 ">
    <p-table showGridlines size="small" class="fullscreen-table" [value]="parcel"
      [(selection)]="selectedParcel" rowSelection="true" dataKey="itemId" [paginator]="true" [rows]="25"
      (onPage)="onPageChange($event)" [tableStyle]="{ 'min-width': '20rem' }" [showCurrentPageReport]="true"
      currentPageReportTemplate="{first} - {last} of {totalRecords}" [rowsPerPageOptions]="[25, 50, 100,200,500,1000]"
      (selectionChange)="checkSelection();"
      [paginatorPosition]='"top"'
      [paginatorStyleClass]="'parcel-list-table-paginator'">
      >
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 0%">
            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
          </th>
          <th style="width:15%" pSortableColumn="timestamp">
            <div class="flex justify-content-between items-center w-full">
              <span>Date</span>
              <p-sortIcon field="timestamp" />
            </div>
          </th>
          <th style="width:12%">Time</th>
          <th style="width:10%">Camera</th>
          <th style="width:10%">Assignee</th>
          <th style="width:12%">ParcelId</th>
          <th>
            Actions
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-parcel let-ri="rowIndex">
        <tr [pSelectableRow]="parcel">
          <td>
            <p-tableCheckbox [value]="parcel"></p-tableCheckbox>
          </td>
          <td>{{ parcel.timestamp | date: 'dd-MM-yyyy'}}</td>
          <td>{{ parcel.timestamp | date: 'HH:mm:ss':'UTC'}}</td>
          <td>{{parcel.cameraName}}</td>
          <td>{{ parcel.userId }}</td>
          <td>
            <a href="javascript:void(0)" class="text-to-button" (click)="onParcelClick(parcel)">
              {{ parcel.itemId }}
            </a>
          </td>
          <td>
            <p-select [style]="{'width':'100%'}" [options]="users" [(ngModel)]="parcel.selectedUser"
              placeholder="Assignee" [editable]="true" [filter]="true" appendTo="body"
              [disabled]="selectedParcel.length > 0"
              (onChange)="onParcelAssigneeSelection(parcel);singleSelections = true" [showClear]="true" />
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td colspan="8" style="text-align: center;"> <strong>No records found.</strong></td>
          </tr>
        </ng-template>
      </p-table>

    </div>
  </div>
  <!-- Action bar below the table -->
  @if (selectedParcel.length > 0 || itemsFromSingleSelections.length > 0) {
    <div class="floating-action-bar">
      <div class="flex justify-content-end align-items-center gap-3">
        @if (selectedParcel.length > 0 && isAdmin) {
          <div class="flex justify-content-center gap-2 pr-4" (click)="deleteConfirm($event)"
            >
            <p-button icon="pi pi-trash" severity="danger" [disabled]="selectedParcel.length > 1" />
            </div>
          }
          @if (selectedParcel.length > 0) {
            <p-select [style]="{'width':'175px'}" [options]="BulkUsersList"
              [(ngModel)]="bulkUpdateUserId" placeholder="Assignee" [filter]="true" appendTo="body"
              [showClear]="(bulkUpdateUserId != '')?true:false" />
          }
          <p-button label="Assign" (click)="onAssign()" severity="success" type="button"
            [pTooltip]="getToolTipFormattedText()" tooltipPosition="top"
            [disabled]="selectedParcel.length > 0 ? !bulkUpdateUserId : false" />
          </div>
        </div>
      }
      <p-confirmDialog [closable]="enableClose">
      </p-confirmDialog>


      <p-toast key="actionToast" (onClose)="closeToast()">
        <ng-template let-message pTemplate="message">
          <div class="custom-toast">

            <div class="toast-content">
              <div>
                <strong>{{ message.summary }}</strong>
                <div>{{ message.detail }}</div>
              </div>

              <button
                pButton
                type="button"
                class="p-button-text p-button-sm undo-btn"
                (click)="onUndo()">
                Undo (<span class="timer-txt"> {{timeLeft}}s</span>)
              </button>
            </div>

          </div>
        </ng-template>
      </p-toast>